import type { HeadCasingSettings } from "building-types/settings/headCasingSettings";
import { ApronCasingType, HeadCasingType, SideCasingType } from "building-types/settings/settingsTypesEnum";

export function apronCasingEnabled(apronCasingType: ApronCasingType): boolean {
  return apronCasingType === ApronCasingType.TRIM;
}

export function sideCasingEnabled(sideCasingType: SideCasingType): boolean {
  return sideCasingType === SideCasingType.TRIM;
}

export function headCasingEnabled(headCasingType: HeadCasingType | undefined): boolean {
  if (!headCasingType) {
    return false;
  }
  return headCasingType !== HeadCasingType.NONE;
}

export function headCasingRemoveCorner(settings: HeadCasingSettings): boolean {
  const { headCasingType } = settings;
  if (headCasingType === HeadCasingType.TRIM) {
    return settings.removeCorner ?? false;
  }
  return false;
}

export function headCasingExtension(settings: HeadCasingSettings): number {
  const { headCasingType } = settings;
  switch (headCasingType) {
    case HeadCasingType.TRIM:
      if (settings.removeCorner) {
        return 0;
      }
    case HeadCasingType.STONE:
    case HeadCasingType.JACK_ARCH:
    case HeadCasingType.FULL_ARCH:
      return settings.headCasingExtension ?? 0;
    case HeadCasingType.NONE:
    default:
      return 0;
  }
}
